import configService from './config.service';

const getAuthToken = async (instance, account) => {
    const accountScopes = configService.azureAdMsal.scope.scopes;
    const tokenResponse = await instance.acquireTokenSilent({ scopes: accountScopes, account: account });
    return tokenResponse.accessToken;
};

export { getAuthToken };
